import { Component, inject } from '@angular/core';
import { DocumentTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  DocumentTypeCreateDto,
  DocumentTypeDto,
  DocumentTypeExcelDownloadDto,
  DocumentTypeUpdateDto,
} from '../proxy/controlling/dtos/document-type';
import { DOCUMENTTYPE_CONFIG, DOCUMENTTYPE_FIELDS } from './document-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-document-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, DocumentTypeService, ConfirmationService],
  templateUrl: './document-type.html',
  styleUrl: './document-type.scss',
})
export class DocumentType extends BaseCrudComponent<
  DocumentTypeDto,
  DocumentTypeCreateDto,
  DocumentTypeUpdateDto,
  DocumentTypeExcelDownloadDto
> {
  service = inject(DocumentTypeService);
  config = DOCUMENTTYPE_CONFIG;
  fields = DOCUMENTTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: DocumentTypeDto): DocumentTypeUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'DocumentType';
  }
}
